const salaryInsightTextCategories = [
	{
		path: '/jobs/salary-insight-text-categories/list',
		name: 'jobs-salary-insight-text-categories-list',
		component: () => import('@/views/jobs/salary-insight-text-categories/list.vue'),
		meta: { layout: 'content', module: 'MGJ,salary' },
	},
]

export default salaryInsightTextCategories
